import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class GoalError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('GoalError', ...args);
    }
}
export default GoalError;
